export enum PlatformMode {
  TestSmarter = 'ts',
  IRhythm = 'ir',
}

export const PLATFORM_MODE_LABELS: Record<PlatformMode, string> = {
  [PlatformMode.TestSmarter]: 'TestSmarter',
  [PlatformMode.IRhythm]: 'iRhythm',
}

export const PLATFORM_MODE_HINTS: Record<PlatformMode, string> = {
  [PlatformMode.TestSmarter]: 'DMEs see test results, reports and qualification stats.',
  [PlatformMode.IRhythm]:
    'DMEs get no clinical results: no AHI/ODI values, qualification groups, reports, result emails or API/Brightree results.',
}

// DME order list columns that disclose clinical results, hidden in iRhythm mode.
export const IRHYTHM_HIDDEN_DME_ORDER_COLUMNS = ['odi', 'ahi', 'oxygenDelivery']

// DME order view tabs that show results, hidden in iRhythm mode.
export const IRHYTHM_HIDDEN_DME_ORDER_TABS = ['report', 'oxygenSetup']

// DME order documents that are reports, hidden in iRhythm mode.
export const IRHYTHM_HIDDEN_DME_DOCUMENT_TYPES = ['MOVED_REPORT']

// DME sidebar labels (by menu key) replaced in iRhythm mode.
export const IRHYTHM_DME_MENU_LABELS: Record<string, string> = {
  'hst--report-complete': 'Completed',
}
